import { SimpleList } from "../lists/SimpleList";
import { Fake } from "../skeleton/Fake";
import { SearchEventAndOrganisationResultsContainer } from "components/layout/home/SearchEventAndOrganisationResults";
import { EventCard } from "components/routes/root/eventCard/EventCard";
import { EventCardMainSection } from "components/routes/root/eventCard/EventCardMainSection";
import { Stack, Typography } from "@mui/material";
import { EventCardDetailsSection } from "components/routes/root/eventCard/EventCardDetailsSection";
import { useFeatureFlags } from "components/providers/featureFlags/useFeatureFlags";

export const SearchEventAndOrganisationResultsSkeleton = () => {
    const enableFeatureFlags = useFeatureFlags();

    if (!enableFeatureFlags) {
        return <div role="status" aria-label="loading" className="skeleton">
            <SimpleList>
                {[...new Array(3)].map((_, key) => ({ key, title: <Fake size={50} />, description: <Fake size={30} /> }))}
            </SimpleList>
        </div>;
    }
    
    return <div role="status" aria-label="loading" className="skeleton">
        <SearchEventAndOrganisationResultsContainer>
            {[...new Array(3)].map((_, key) => <EventCard key={key} fullWidth>
                <EventCardMainSection mb={0.125}>
                    <Stack direction="row" spacing={2} justifyContent="space-between">
                        <Typography variant="label2"><Fake size={28} /></Typography>
                        <Typography variant="body"><Fake size={16} /></Typography>
                    </Stack>
                    <Typography variant="h7"><Fake size={42} /></Typography>
                </EventCardMainSection>
                <EventCardDetailsSection>
                    <Typography variant="h4" py={0.125}><Fake size={7} /></Typography>
                </EventCardDetailsSection>
            </EventCard>)}
        </SearchEventAndOrganisationResultsContainer>
    </div>;
};
